/**
 * Single switch: when true, flow schedule mutations use POST /flows/:flowId/mutations instead of WebSocket flowSync / PATCH.
 * Default in `.env.example` is true after Phase 5 QA; set false only to force the legacy socket path.
 */
export function isFlowHttpMutationsEnabled(): boolean {
  return import.meta.env.VITE_FLOW_HTTP_MUTATIONS === 'true';
}
